import { Component, OnInit, Input } from "@angular/core";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "circle-brothers-discounts",
  templateUrl: "circleBrDiscounts.component.html",
})
export class CirleBrDiscountsComponent implements OnInit {
  loading = false;
  messages: any;
  circleData: any = [];

  constructor(
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  validateData(circleRecord) {
    let errorMessage = "";
    if (!circleRecord) errorMessage = "אין מידע";
    else if (circleRecord.circleId === undefined) errorMessage = "אין מעגל";
    // 	else if (!circleRecord.fromHoursNew || refund.fromHoursNew < 0 ||
    // 		!refund.toHoursNew || refund.toHoursNew < 0 || !refund.refundPercentNew || refund.refundPercentNew < 0)
    // 		errorMessage = 'חייב מספר';
    // 	else if (refund.fromHoursNew > refund.toHoursNew)
    // 		errorMessage = 'יחס לא תקין של שעות';
    return errorMessage;
  }

  saveRecord(circleRecord) {
    let errorMessage = this.validateData(circleRecord);
    if (errorMessage != "") {
      this.alertService.error(errorMessage);
    } else {
      this.loading = true;
      let requestData = {
        circleId: circleRecord.circleId,
        brother2: circleRecord.brother2New,
        brother3: circleRecord.brother3New,
        brother4: circleRecord.brother4New,
      };
      this.dataService.saveCircleData(requestData).subscribe(
        (data) => {
          this.loading = false;
          this.alertService.success("נשמר בהצלחה");

          circleRecord.brother2 = circleRecord.brother2New;
          circleRecord.brother3 = circleRecord.brother3New;
          circleRecord.brother4 = circleRecord.brother4New;
          circleRecord.edit = false;
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
    }
  }

  openEditMode(cd) {
    if (this.circleData && this.circleData.length) {
      this.circleData.forEach((r) => {
        if (r.circleId != cd.circleId) r.edit = false;
      });
    }
    cd.edit = true;
    cd.brother2New = cd.brother2;
    cd.brother3New = cd.brother3;
    cd.brother4New = cd.brother4;
  }

  ngOnInit() {
    this.loading = true;
    this.dataService.getCircleData().subscribe(
      (data) => {
        this.loading = false;
        this.circleData = data && data.circleData ? data.circleData : [];
      },
      (error) => {
        let body = error.json && error.json();
        this.alertService.error(
          body && body.statusText
            ? this.messages[body.statusText]
              ? this.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || error
        );
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/circle_discounts/circleBrDiscounts.component.ts